export default "__VITE_ASSET__Bvhu9a71__"